
































































































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetAutCodeList} from '../../../api/basicDictionary'
import {GetListByCode} from '../../../api/configureDictionary'
import {GetChkitemList, InsertChkitem, UpdateChkitemById, DeleteChkitem, GetUtcodeList} from '../../../api/specialDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'chkName',
			title: '项目名称'
		},
		{
			key: 'price',
			width: 180,
			title: '单价'
		},
		{
			key: 'chkPY',
			title: '拼音助记符'
		},
		{
			key: 'chkWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	tableLoading = false
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm:any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '180px'
	tableTotalSize = 0
	tableData = []

	units = []	//单位下拉
	codes = []  //费用类别下拉
	rooms = []  //部门下拉
	medicares = []  //医保等级下拉
	statisticals = []  //统计分析下拉
	materialTypes = [] // 物资类型下拉

	created() {
		this.getData()
		this.getSelects()
	}
	//新增按钮
	createCounty() {
		this.dialogTitle = '新增项目'
		this.dialogForm = {
			status: true,
			isCharge: true,
			chkPY: '',
			chkWB: ''
		}
		this.dialogFormVisible = true
	}
	//初始化时获取数据
	private async getData() {
		this.tableLoading = true
		let res = await GetChkitemList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}
	// 获取所有下拉
	async getSelects(){
		let query = {QueryString:'', SkipCount:1, MaxResultCount:10000}
		let res1 = await GetListByCode({input: "007"})  //物资类型
		this.materialTypes = res1
		let res2 = await GetAutCodeList({Page:1, PageSize:10000})
		this.units = res2.items
		let res3 = await GetListByCode({input: "010"})
		this.codes = res3
		let res4 = await GetUtcodeList(query)
		this.rooms = res4.items
		let res5 = await GetListByCode({input: "003"})
		this.medicares = res5
		let res6 = await GetListByCode({input: "022"})
		this.statisticals = res6

	}
	handleClose() {
		this.dialogFormVisible = false
	}
	//获取拼音五笔
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.chkPY = res1
		this.dialogForm.chkWB = res2
	}
	edit(row: any) {
		this.dialogTitle = '编辑项目'
		this.dialogForm = Object.assign(row)
		this.units.forEach((item:any)=>{
			if (this.dialogForm.unit === item.id) {
				this.dialogForm.uni = item
				return
			}
		})
		this.codes.forEach((item:any)=>{
			if (this.dialogForm.codeId === item.id) {
				this.dialogForm.code = item
				return
			}
		})
		this.rooms.forEach((item:any)=>{
			if (this.dialogForm.utId === item.id) {
				this.dialogForm.ut = item
				return
			}
		})
		this.medicares.forEach((item:any)=>{
			if (this.dialogForm.medicareLevel === item.id) {
				this.dialogForm.medicare = item
				return
			}
		})
		this.statisticals.forEach((item:any)=>{
			if (this.dialogForm.statisticalClass === item.id) {
				this.dialogForm.statistical = item
				return
			}
		})
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteChkitem({Id: row.id})
			this.getData()
		}).catch(() => {
			this.$message({
				type: 'info',
				message: '已取消删除'
			});
		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增项目') {
					let res = await InsertChkitem(this.dialogForm)
				} else if (this.dialogTitle === '编辑项目') {
					let res = await UpdateChkitemById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}
	rules = {
		chkName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		chkPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		chkWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
		otherName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		otherNamePY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		otherNameWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	codeChange(item: any){
		this.dialogForm.codeId = item.id
		this.dialogForm.codeName = item.text
	}
	unitChange(item: any){
		this.dialogForm.unit = item.id
		this.dialogForm.unitName = item.autName
	}
	roomChange(item: any){
		this.dialogForm.utId = item.id
		this.dialogForm.utName = item.deptName
	}
	medicareChange(item: any){
		this.dialogForm.medicareLevel = item.id
		this.dialogForm.medicareLevelName = item.text
	}
	statisticalChange(item: any){
		this.dialogForm.statisticalClass = item.id
		this.dialogForm.statisticalClassName = item.text
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/item/index.vue